import React from "react";
import {Box, Grid, Typography} from "@mui/material";
import {PartnerBlock} from "./Partners/PartnerBlock";
import content from '../assets/data/partners.json'

const p1 = {
    title: "TITLE PARTNER",
    lg: 2.2,
    md: 6,
    xs: 6,
    list: [
        {
            "image":"fuzetea.png",
            "link":""
        }
    ]
}

export const Partners = () => {
    return (
        <Box sx={{background:'#fff', py:10}} id={'partners'}>
            <Typography color={'#509F33'} textAlign={'center'} variant={'h3'} fontFamily={'Blur'} fontWeight={{xs:700}}>
                PARTNERS
            </Typography>
            <Box sx={{width:'min(100%, 100rem)', margin:'auto',px: {xs:2, md:3}, pt:3}}>
                <Grid container justifyContent={'center'} spacing={2} sx={{pb:2}}>
                    <PartnerBlock partner={p1}/>
                </Grid>
                {content.map((row) =>
                    <Grid key={row.id} container justifyContent={'center'} spacing={2} sx={{pb: 2}}>
                        {row.items.map((p) =>
                            <PartnerBlock key={p.id} partner={p}/>
                        )}
                    </Grid>
                )}
            </Box>
        </Box>
    )
}
